














































































































































































































































import {Emit} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Component} from '@/shared/component';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';
import {Client, Contact, Token} from '@/models';

import storeClient from '@/stores/modules/client';
import storeToken from "@/stores/modules/token";
import storeContact from "@/stores/modules/contact";

import CrudAddressShow from '@/components/Crud/Address/Show.vue';
import CrudContactList from '@/components/Crud/Contact/ListClient.vue';
import CrudClientEditDialogLight from '@/components/Crud/Client/EditDialogLight.vue';
import CrudClientEditDialogPrixClient from '@/components/Crud/Client/EditDialogPrixClient.vue';
import CrudClientAdressesEditDialog from '@/components/Crud/Client/EditAdressesDialog.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import CrudContactEditDialog from '@/components/Crud/Contact/EditDialog.vue';

@Component({
	components: {
		CrudAddressShow,
		CrudContactList,
		CrudClientEditDialogLight,
		CrudClientAdressesEditDialog,
		CrudClientEditDialogPrixClient,
		CrudDeleteDialog,
		CrudContactEditDialog,
	}
})
export default class CrudClientShow extends AbstractShowVue<Client> {

	private imgPath: string = "";

	private editClient: Client = null;
	private editClientAdresses: Client = null;

	private editContact: Contact = null;
	private deletedContact: Contact = null;

	private editPrixClient: Contact = null;

	@Stored(() => storeToken)
	private token: Token;

	private storeContact = storeContact;

	public constructor() {
		super(storeClient);
	}

	public async mounted(): Promise<void> {
		storeContact.state.filters.clear();
		await super.mounted();
		console.log(this.value.prixClients.length)
	}

	public async refresh(value: any): Promise<void> {
		await super.refresh(value);

		if (this.item !== null)
		{
			this.imgPath = "/img/files/proprietaire.jpg";

			if (this.$route.name === 'client-show') {
				this.$route.meta.title = 'Détails  d\'un client';
			}
		}

	}

	@Emit()
	private onCreateContact(): void {
		this.editContact = new Contact();
		this.editContact.client = this.item;
	}

	private async refreshContacts(): Promise<void> {
		await Promise.all([
			storeContact.dispatch('getC', { filters: true }),
			this.refresh(this.value),
		]);
	}

}
